import {
  RegionList,
  RegionListItem,
  RegionListOption,
} from '@virginexperiencedays/components-v2/src/layout/RegionList';

import type { ComponentProps } from 'react';
import type { Regions } from '@virginexperiencedays/components-v2/src/pages/product/Locations';

type RegionLocationOptionsProps = ComponentProps<typeof RegionList> & {
  regions: Regions;
  regionNames: string[];
  activeRegion: string;
  onClickAllLocation: () => void;
  onClickOption: (name: string) => void;
};

export const RegionLocationOptions = ({
  regions,
  regionNames,
  activeRegion,
  onClickAllLocation,
  onClickOption,
  ...rest
}: RegionLocationOptionsProps) => {
  return (
    <RegionList {...rest}>
      <RegionListItem>
        <RegionListOption
          onClick={onClickAllLocation}
          isActive={!activeRegion}
          className="py-3 md:py-2"
        >
          <div className="flex">
            <span className="text-base font-medium leading-normal md:text-sm md:leading-none">
              All locations
            </span>
          </div>
        </RegionListOption>
      </RegionListItem>
      {regionNames.map((name) => (
        <RegionListItem key={`region-filter-${name}`}>
          <LocationOption
            key={name}
            name={name}
            onClickOption={onClickOption}
            activeRegion={activeRegion}
            regionCount={regions?.[name]?.length || 0}
            className="py-3 text-base md:py-2 md:text-sm"
          />
        </RegionListItem>
      ))}
    </RegionList>
  );
};

type LocationOptionProps = ComponentProps<typeof RegionListOption> & {
  name: string;
  regionCount: number;
  activeRegion: string;
  onClickOption: (name: string) => void;
  className?: string;
};

export const LocationOption = ({
  name,
  regionCount,
  activeRegion,
  onClickOption,
  ...rest
}: LocationOptionProps) => {
  const isActive = name === activeRegion;
  return (
    <RegionListOption onClick={() => onClickOption(name)} isActive={isActive} {...rest}>
      <div className="flex flex-wrap items-center">
        <p className="line-clamp-1 text-ellipsis text-left leading-normal">
          <span className="font-medium">{name}</span>
          <span className="ml-1 text-sm font-normal">
            ({regionCount} {regionCount && regionCount > 1 ? 'locations' : 'location'})
          </span>
        </p>
      </div>
    </RegionListOption>
  );
};
